import { render } from "./payroll-history.vue?vue&type=template&id=4a9266f0&scoped=true"
import script from "./payroll-history.vue?vue&type=script&lang=js"
export * from "./payroll-history.vue?vue&type=script&lang=js"

import "./payroll-history.vue?vue&type=style&index=0&id=4a9266f0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9266f0"]])

export default __exports__